<div class="modal__overlay flex flex-col">
  <div class="model" [ngClass]="size + '__model'">
    <div class="model__header">
      <div
        class="close__icon"
        inlineSVG="nav/close.svg"
        (click)="onClose.emit()"
      ></div>
    </div>
    <div class="modal__body">
      <ng-content></ng-content>
    </div>
    @if (btnCancelName || btnSubmits?.length) {
      <div class="modal__actions flex gap-2">
        <button
          *ngIf="btnCancelName"
          (click)="onClose.emit()"
          [translate]="btnCancelName"
          class="primary__btn-outline"
        ></button>

        @if (btnSubmits?.length) {
          @for (button of btnSubmits; track $index) {
            <button
              (click)="onSubmit.emit(button.id)"
              [translate]="button.name"
              [title]="button.title | translate"
              class="primary__btn"
            ></button>
          }
        }
      </div>
    }
  </div>
</div>
